import { Phone } from "@phosphor-icons/react";
import { useSettings } from "@/contexts/SettingsContext";

// Sitewide "Call Us" button — number, label and visibility all editable once
// from Admin -> Header, reflected everywhere this button appears.
export const CallButton = ({ className = "btn-outline gap-2", testId = "call-button" }) => {
  const settings = useSettings();
  const phoneNumber = settings.phone_number;

  if (settings.call_button_enabled === false || !phoneNumber) return null;

  return (
    <a href={`tel:${phoneNumber.replace(/[^\d+]/g, "")}`} data-testid={testId} className={className}>
      {settings.call_button_label || "Call Us"}
      <Phone size={18} weight="bold" />
    </a>
  );
};
